import { render, staticRenderFns } from "./SettingsItemValue.vue?vue&type=template&id=4440ce26&scoped=true&"
import script from "./SettingsItemValue.vue?vue&type=script&lang=js&"
export * from "./SettingsItemValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4440ce26",
  null
  
)

export default component.exports